import { render, staticRenderFns } from "./naj-no-data.vue?vue&type=template&id=0011ba66&scoped=true&"
import script from "./naj-no-data.vue?vue&type=script&lang=js&"
export * from "./naj-no-data.vue?vue&type=script&lang=js&"
import style0 from "./naj-no-data.vue?vue&type=style&index=0&id=0011ba66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0011ba66",
  null
  
)

export default component.exports